import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Comecar from "@/pages/Comecar";
import Resultado from "@/pages/Resultado";
import Cancelado from "@/pages/Cancelado";
import Obrigado from "@/pages/Obrigado";
import Admin from "@/pages/Admin";
import { Privacidade, Termos } from "@/pages/Legal";
import { WhatsAppFab } from "@/components/WhatsAppFab";

function FloatingWhatsApp() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <WhatsAppFab />;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/comecar" element={<Comecar />} />
          <Route path="/resultado" element={<Resultado />} />
          <Route path="/cancelado" element={<Cancelado />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
